import {Link, NavLink, useNavigate} from "react-router-dom";
import {useAuthStore} from "../../store/user-store";
import NoImage from '../../assets/images/no-image.png'
import {useEffect} from "react";


export default function Layout({children}) {
    const auth_store = useAuthStore()
    const redirect = useNavigate()
    const logOut = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        auth_store.logOut()
        redirect('/')
    }

    const getLabelGroup=(group)=>{
        switch (group){
            case 'group1':

               return auth_store.settings?.label1
                break;
            case 'group2':

               return auth_store.settings?.label2
                break;
            case 'group3':

                return auth_store.settings?.label3
                break;
            case 'group4':

                return auth_store.settings?.label4
                break;
            case 'group5':

                return auth_store.settings?.label5
                break;
            case 'group6':

                return auth_store.settings?.label6
                break;
        }
    }
    useEffect(() => {

        document.title = auth_store.settings?.name || 'الصفحة الرئيسية'
        if (auth_store.settings?.logo) {
            const link = document.querySelector("link[rel~='icon']");
            if (link) {
                link.href = auth_store.settings.logo;
            }
        }
    }, [auth_store.settings])

    return (
        <>

            <section  className={`${auth_store.gradient?'bg-gradient-main':'bg-color'} section-wrapper`}>

                <nav className={`navbar ${auth_store.gradient?'bg-gradient-main':'nav-color'} nav-h fixed-top border-botom-white box-shadow mb-4`} dir={'ltr'}>
                    <div className="container-fluid">
                        <Link to={'/'} className="navbar-brand text-white">{auth_store.settings?.name}  </Link>
                        <Link style={{textDecoration:'none'}} to={'/pricing'} className={'text-white'}>
                            {auth_store.user !== null ?<img className={'group-img-top'} src={auth_store.user?.group_img} alt=""/>:null}
                            <span> </span>
                            {auth_store.user !== null ?<span> <i className="fa fa-cash"></i>{auth_store.formatCurrency(auth_store.user?.balance)}</span>:null}


                        </Link>
                        <button className="btn bg-secondary" type="button" data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"><i
    className={'fa fa-bars fa-lg text-white'}/>
                        </button>

                    </div>

                </nav>

                {/* Start SideBar */}
                <div className="offcanvas offcanvas-end bg-secondary sidebar-width" tabIndex="-1" id="offcanvasRight"
                     aria-labelledby="offcanvasRightLabel">
                    <div className="offcanvas-header bg-secondary">
                        <div className="d-flex justify-content-between align-items-center flex-1 ">
                            <h5 className="offcanvas-title text-white flex-1"
                                id="offcanvasRightLabel"></h5>
                            <button type="button" className="bg-transparent border-0 text-white"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close">
                                <i className="fa fa-close"></i>
                            </button>
                        </div>
                    </div>
                    <div className="offcanvas-body bg-secondary">
                        <ul className={'nav flex-column'} data-bs-dismiss="offcanvas"
                            aria-label="Close">
                            <li className={'nav-item   text-right'}>
                                {auth_store.user?.id!=null ? <div className="d-flex flex-column justify-content-center align-items-center">
                                    <img src={auth_store.user?.img??NoImage} style={{width:60,height:60}} className={'rounded-circle'} alt=""/>
                                    <div className="w-100 d-flex flex-row justify-content-around align-items-center">
                                        <span className={'text-white'}>{auth_store.user?.name}</span>
                                       <Link to={'/pricing'} style={{textDecoration:'none'}}>

                                           {/*<div className="d-inline-block px-1 py-1 rounded" style={{backgroundColor:"#D6D6D6"}}>*/}
                                           <img src={auth_store.user?.group_img} style={{width:45,height:45}} alt=""/>
                                           <span className={'text-white'} style={{fontSize:10}}>{getLabelGroup(auth_store.user.group)}</span>
                                           {/*</div>*/}
                                       </Link>
                                    </div>
                                    <span className={'text-danger'}>{auth_store.formatCurrency(auth_store.user?.balance)} </span>
                                    <div className=" w-100 d-flex flex-row justify-content-around align-items-center gap-2">
                                        <span style={{cursor:'pointer'}} onClick={logOut}><i className="fa fa-right-from-bracket text-white"></i></span>
                                        <Link to={'/profile'}><i className="fa fa-user text-white"></i></Link>
                                    </div>
                                </div> : null}

                                  </li>
                            <li className={`border border-botom-white ${auth_store.user==null?'d-none':''}`}></li>
                            <li className={'nav-item my-2 border border-white border-1 rounded '}>

                                <Link className={'nav-link  text-white'} to={'/'}> <i
                                    className="fa fa-home text-orange mx-2"/>الرئيسية</Link>
                            </li>
                            {auth_store.user !== null ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/payments'}>{/*<i
                                    className="fa fa-cash-register text-orange mx-2"/>*/}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                         className="bi bi-cash-coin text-orange mx-2" viewBox="0 0 16 16">
                                        <path fillRule="evenodd"
                                              d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8m5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0"/>
                                        <path
                                            d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195z"/>
                                        <path
                                            d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083q.088-.517.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1z"/>
                                        <path d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 6 6 0 0 1 3.13-1.567"/>
                                    </svg>
                                    إضافة رصيد</Link>
                            </li> : null}
                            {auth_store.user !== null ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/charges'}><i
                                    className="fa fa-circle-dollar-to-slot text-orange mx-2"/>دفعاتي</Link>
                            </li> : null}

                            {auth_store.user !== null ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/balances'}>{/*<i
                                    className="fa fa-dollar-sign text-orange mx-2"/>*/}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                                         className="bi bi-cash-stack text-orange mx-2" viewBox="0 0 16 16">
                                        <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>
                                        <path
                                            d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2z"/>
                                    </svg>
                                    محفظتي</Link>
                            </li> : null}
                            {auth_store.user !== null ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/orders'}><i
                                    className="fa fa-cart-shopping text-orange mx-2"/>طلباتي</Link>
                            </li> : null}
                            {auth_store.user !== null && auth_store.online===true ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/invoices'}><i
                                    className="fa fa-mobile-retro text-orange mx-2"/>طلبات الأرقام</Link>
                            </li> : null}
                            {auth_store.user === null ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/login'}><i
                                    className="fa fa-right-to-bracket text-orange mx-2"/>تسجيل الدخول</Link>
                            </li> : null}
                            {auth_store.user === null ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/register'}><i
                                    className="fa fa-id-card text-orange mx-2"/>تسجيل جديد</Link>
                            </li> : null}
                            {auth_store.user !== null ? <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/notifications'}><i
                                    className="fa fa-bell text-orange mx-2"/>الإشعارات </Link>
                                </li>:null}
                            <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <Link className={'nav-link  text-white'} to={'/about'}><i
                                    className="fa fa-id-card text-orange mx-2"/> من نحن</Link>
                            </li>
                            <li className={'nav-item my-2 border border-white border-1 rounded'}>
                                <a className={'nav-link  text-white '} style={{fontSize:'14px'}} href={`https://wa.me/${auth_store.settings?.whatsapp.replace('+','').replaceAll(' ','')}`} target={'_blank'}><i
                                    className="fa-brands fa-whatsapp whatsapp-icon fa-xl mx-2 small" /> تواصل مع الإدارة </a>
                            </li>


                           {/* {auth_store.user != null ? <li className={'nav-item w-100 my-2'} onClick={logOut}>
                                <span className={' nav-link text-white'}><i
                                    className="fa fa-right-from-bracket text-orange mx-2"/>خروج</span>
                            </li> : null}*/}

                            <li className={'nav-item my-2 border-1 border-top pt-2 gap-2 d-flex'}>
                                {/*<a className={'nav-link  text-white'} target={'_blank'} rel="noopener noreferrer" href={`https://wa.me/${auth_store.settings?.whatsapp}`}>
                                    <i className="fa-brands fa-whatsapp  text-orange fa-lg mx-2" />تواصل مع الإدارة</a>*/}

                                <a href={auth_store.settings?.facebook} target={'_blank'} className={'social-icons'}>
                                    <i className="fa-brands fa-facebook fa-xl facebook-icon"/>
                                </a>
                                <a href={auth_store.settings?.telegram} target={'_blank'} className={'social-icons'}>
                                    <i className="fa-brands fa-telegram fa-xl telegram-icon"/>
                                </a>
                                <a href={auth_store.settings?.instagram} target={'_blank'} className={'social-icons'}>
                                    <i className="fa-brands fa-instagram fa-xl instagram-icon"/>
                                </a>
                                <a className={'social-icons'} href={`https://wa.me/${auth_store.settings?.whatsapp.replace('+','').replaceAll(' ','')}`} target={'_blank'}>
                                    <i className="fa-brands fa-whatsapp whatsapp-icon fa-xl"/>
                                </a>

                            </li>
                        </ul>
                    </div>
                </div>
                {/* End SideBar */}
                <div className={'wrapper min-100-vh'}>
                    {children}
                </div>

            </section>
            <footer className={'bottom-nav py-2 d-block d-md-none'}>
                <div className="d-flex justify-content-around align-items-center">

                    <NavLink to={'/balances'}>
                        {auth_store.icon==='syr'?<i className={'fa fa-lira-sign fa-lg text-white'}/>:null}
                        {auth_store.icon==='coins'?<i className="fa-solid fa-coins fa-lg text-white"/>:null}
                        {auth_store.icon==='usd'?<i className="fa fa-dollar-sign fa-lg text-white"/>:null}
                    </NavLink>

                    <NavLink to={'/orders'}><i className="fa fa-shopping-cart fa-lg text-white"></i></NavLink>
                    <NavLink to={'/'}><i className="fa fa-home fa-lg text-white"></i></NavLink>
                    <NavLink to={'/invoices'}><i className="fa fa-mobile fa-lg text-white"></i></NavLink>
                    <NavLink to={'/notifications'}><i className="fa fa-bell fa-lg text-white"></i></NavLink>

                </div>
            </footer>

        </>

    );
}
